import React from "react"

import "./HandrulesEntry.css"
import requestHandler from "../../../utils/requestHandler";
import { UserAuth } from "../../../context/AuthContext";
import pointing from "../../../assets/icons/pointing.svg"

const HandrulesEntry = ({type, name, no, token}) => {
	return (
		<div className="entryContainer">
			<div className="ruleType">{type[0]}</div>
			<div className="ruleUser">{name}</div>
			{no !== undefined ? (<div className="ruleNo" onClick={() => token ? requestHandler(`handrules/69/${no}`, 'DELETE', token) : undefined}>
				<img src={pointing} alt="pointing" />
			</div>) : (<div></div>)}
		</div>
	)
}

export default HandrulesEntry;